import React, { useContext } from "react";
import "./Contact.scss";
import { Stack, Link, Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import TotalEnergiesContext from "../../core/store/context/TotalEnergiesContext";

interface ContactProps {
  handleGoBackClick?: () => void;
}

export const Contact = ({ handleGoBackClick }: ContactProps) => {
  const { t } = useTranslation();
  const { isAgent } = useContext(TotalEnergiesContext);

  return (
    <>
      <Stack className="contact-component">
        <Link
          className="my-personal-data__button"
          component="button"
          underline="none"
          onClick={handleGoBackClick}
          variant="button"
          sx={{ marginBottom: { xs: "56px", lg: 5 }, paddingY: "14px" }}
        >
          {" "}
          <Typography
            component="span"
            className="t-icon-long-arrow-left"
            aria-hidden="true"
            paddingRight={"10px"}
          />
          {t("Botón volver")}
        </Link>
        <Typography
          component="h3"
          variant="h3"
          sx={{ paddingBottom: { xs: "32px", headerMobile: "53px" } }}
        >
          <span
            className="t-icon-phone brand-red"
            style={{ paddingRight: "15px" }}
          />{" "}
          {t("Header.Perfil.Contacto")}
        </Typography>
        <Stack direction="column">
          <Typography
            component="span"
            variant="subtitle1"
            className="title brand-red need-help"
            paddingBottom={2}
          >
            {t("Footer.Título")}
          </Typography>
          <Box className="subtitle brand-gray" paddingBottom={2}>
            <Typography variant="body1">
              <span className="t-icon-mail brand-red icon" />
              {t(`Footer.Email contacto${isAgent ? " agentes" : ""}`)}
            </Typography>
          </Box>
          {!isAgent && (
            <Box className="subtitle brand-gray" paddingBottom={2}>
              <Typography variant="body1">
                <span
                  className="t-icon-phone brand-red icon"
                  aria-hidden="true"
                />
                {t("Footer.Teléfono contacto")}
              </Typography>
            </Box>
          )}
        </Stack>
      </Stack>
    </>
  );
};

export default Contact;
